module.exports = __webpack_public_path__ + "static/CandidateMonitoring-5565476a76dbca1f99f6cd761b675c3b.png";